module.exports = __webpack_public_path__ + "img/SketchPng198db0a4180b206a6182375da265e1271ddd4daea7273abce435f630eae91be8.5da0fed8.png";